import template from 'marketplace/marketplace-meta.j2';
import { mDom } from '../../../core/js/utils/renderUtils';
import { generate } from '../../../core/js/utils/componentUtils';
import { onStateChange } from '../utils/productComponentUtils';

export function init(store, overrides = {}) {
    const config = {
        templateLocation: '.dom-pdp .dom-main-product .dom-marketplace-meta',
        watch: 'product.selectedSku',
        template: template,
        name: 'marketplaceMetaComponent',
        forFamilyProduct: false,
        onStateChange: onStateChange,
        renderType: mDom
    };

    return generate(config, store, overrides);
}
